import {initData} from "@telegram-apps/sdk";
import {Notify} from "quasar";

export default function () {
    initData.restore()

    const user = initData.user()

    if(user) {
        const echo = useEcho()

        echo.private('notifications.' + user.id)
            .listen('.suggest.moderated', (data: any) => {
                Notify.create(data.text)
            })
    }
}